import type { FaireProductEntity } from "../../entity_types/product";

export const p_qq4sgejr94: FaireProductEntity = {
  token: "p_qq4sgejr94",
  type: "product",
  name: "Essentials: Yuzu + Passion Fruit Candle  | 12 oz.",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/449fe22cf53e52c358436a876b5df07433041122fc7ed40e98acae91f9e2e93b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6af9386f43eeb2b5312167b709b4fe6cbe8262651a7dc0f4f7e53d8d59c6bb32.jpeg",
    "https://cdn.faire.com/fastly/a47fd08ba8d7866bca77615be21869433834bb93f12b9a3047b782fed3c91e21.jpeg",
    "https://cdn.faire.com/fastly/9d0b9c725728d7918575492160f774d82e68be8b96c4736ac7a59bcbbcfdc63c.jpeg",
    "https://cdn.faire.com/fastly/7436ceb4e7acdba4b7ac65bef31ab2abf283736a73622dc4f576eec491a3ed5e.jpeg",
  ],
  priceDollars: 22,
  description:
    "An elevated take on the basic, citrus candle– Punchy and bright yuzu is balanced with sweet, tropical passion fruit notes to create this effervescent fragrance. The Botanica Essentials Candle Collection features pure essential oils, balanced with nuanced fragrance oils to create provocative and true-to-nature scents. \n\nFragrance Notes: Passion Fruit, Yuzu, Mandarin\n\n• SOY & COCONUT WAX CANDLE | 100% COTTON WICK \n• 12 oz. | 70+ HOUR BURN TIME",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:45.649Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
